import React, {useState, useEffect} from 'react';
import {useLocation} from 'react-router-dom';

import {text} from '../text';
import {hooks} from '../hooks';
import {utils} from '../utils';
import {svg} from '../assets/svg';
import {theme} from '../constants';
import {components} from '../components';
import { User,MessageCircle } from 'lucide-react'

import Https from '../utils/apiUtility';

// Interface para o assinante
interface SubscriberType {
  nome: string;
  avatar: string;
  telefone: string;
}

// Função para extrair as iniciais do nome
const getInitials = (name: string): string => {
  const words = name.split(" ");
  if (words.length === 1) return words[0].charAt(0).toUpperCase();
  return words[0].charAt(0).toUpperCase() + words[1].charAt(0).toUpperCase();
};

export const Profile: React.FC = () => {
  const {pathname} = useLocation();
  const navigate = hooks.useAppNavigate();
  const [faceID, setFaceID] = useState(true);
  const [notification, setNotification] = useState(true);
  const [subscriber, setSubscriber] = useState<SubscriberType | null>(null);

  useEffect(() => {
    setTimeout(() => {
      window.scroll({top: -1, left: 0, behavior: 'smooth'});
    }, 10);
  }, [pathname]);

  useEffect(() => {
    const fetchSubscriber = async () => {
      try {
        const response = await Https.get("/assinante");
        setSubscriber(response.data);
      } catch (error) {
        console.error("Erro ao buscar assinante:", error);
      }
    };

    fetchSubscriber();
  }, []);

  const renderHeader = (): JSX.Element => {
    return (
      <components.Header
        title='Perfil'
        goBack={true}
      />
    );
  };

  const renderUserInfo = (): JSX.Element => {
    return (
      <div
        style={{ marginBottom: 30, cursor: 'pointer', userSelect: 'none' }}
        onClick={() => navigate('/EditPersonalInfo')}
      >
        {subscriber && (
          <>
            <img
              alt="avatar"
              src={subscriber.avatar ?? `https://placehold.co/400?text=${getInitials(subscriber.nome)}&font=roboto`}
              style={{
                width: 100,
                height: 100,
                borderRadius: 50,
                margin: '0 auto',
                marginBottom: 14,
              }}
            />
            <text.H4 style={{ textAlign: 'center' }}>{subscriber.nome}</text.H4>
            <text.T16 style={{ textAlign: 'center' }}>{subscriber.telefone}</text.T16>
          </>
        )}
      </div>
    );
  };

  const renderMenu = (): JSX.Element => {
    const btnStyle = {
      borderRadius: 10,
      backgroundColor: '#FFF7F2',
      padding: '10px 20px 10px 10px',
      ...utils.rowCenter(),
    };

    return (
      <div style={{marginBottom: 30}}>
        <div
          style={{
            ...btnStyle,
            marginBottom: 8,
            cursor: 'pointer',
            userSelect: 'none',
            background: '#fff',
            border: '1px solid #3a4f90',
          }}
          onClick={() => navigate('/EditPersonalInfo')}
        >
          {/* Ícone Lucide de usuário */}
          <div
            style={{
                padding: 8,
                backgroundColor: theme.colors.lightGrey,
                borderRadius: '20%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
            }}
          >
            <User size={20} color={theme.colors.mainDark} />
          </div>
          <text.H5 style={{marginLeft: 10, marginRight: 'auto'}}>
            Informações pessoais
          </text.H5>
          <svg.RightArrowSvg />
        </div>
        <div
          style={{
            ...btnStyle,
            marginBottom: 10,
            cursor: 'pointer',
            userSelect: 'none',
            background: '#fff',
            border: '1px solid #3a4f90',
          }}
          onClick={() => setNotification(!notification)}
        >
          {/* Ícone Lucide de usuário */}
          <div
            style={{
                padding: 8,
                backgroundColor: theme.colors.lightGrey,
                borderRadius: '20%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
            }}
          >
            <MessageCircle size={20} color={theme.colors.mainDark} />
          </div>
          <text.H5 style={{marginLeft: 10, marginRight: 'auto'}}>
            Notificações
          </text.H5>
          <div
            style={{
              width: 41,
              backgroundColor: notification ? '#55ACEE' : 'lightgray',
              borderRadius: 12,
              padding: '1.5px 1.5px',
              cursor: 'pointer',
              userSelect: 'none',
              display: 'flex',
              flexDirection: 'row',
              justifyContent: notification ? 'flex-end' : 'flex-start',
            }}
          >
            <div
              style={{
                width: 20.9,
                height: 20.9,
                backgroundColor: '#FFFFFF',
                borderRadius: 11,
                alignSelf: notification ? 'flex-end' : 'flex-start',
              }}
            />
          </div>
        </div>
        {/* <div
          style={{
            ...btnStyle,
            marginBottom: 10,
            cursor: 'pointer',
            userSelect: 'none',
          }}
          onClick={() => setFaceID(!faceID)}
        >
          <svg.FaceIDSvg />
          <text.H5 style={{marginLeft: 10, marginRight: 'auto'}}>
            Face ID
          </text.H5>
          <div
            style={{
              width: 41,
              backgroundColor: faceID ? '#55ACEE' : 'lightgray',
              borderRadius: 12,
              padding: '1.5px 1.5px',
              cursor: 'pointer',
              userSelect: 'none',
              display: 'flex',
              flexDirection: 'row',
              justifyContent: faceID ? 'flex-end' : 'flex-start',
            }}
          >
            <div
              style={{
                width: 20.9,
                height: 20.9,
                backgroundColor: '#FFFFFF',
                borderRadius: 11,
                alignSelf: faceID ? 'flex-end' : 'flex-start',
              }}
            />
          </div>
        </div> */}
        {/* <div style={{...btnStyle, cursor: 'pointer', userSelect: 'none'}}>
          <svg.TranslateSvg />
          <text.H5 style={{marginLeft: 10, marginRight: 'auto'}}>
            Language
          </text.H5>
          <div style={{...utils.rowCenter({gap: 11})}}>
            <span
              style={{
                fontSize: 12,
                color: theme.colors.bodyTextColor,
                ...theme.fonts.SourceSansPro_400Regular,
              }}
            >
              Eng
            </span>
            <svg.RightArrowSvg />
          </div>
        </div> */}
      </div>
    );
  };

  const renderButton = (): JSX.Element => {
    return (
      <components.Button
        title='Sair'
        //colorScheme='light'
        onClick={() => navigate('/SignIn')}
      />
    );
  };

  const renderContent = (): JSX.Element => {
    return (
      <main
        className='container'
        style={{marginTop: 52 + 46, marginBottom: 20}}
      >
        {renderUserInfo()}
        {renderMenu()}
        {renderButton()}
      </main>
    );
  };

  return (
    <div id='screen'>
      {renderHeader()}
      {renderContent()}
    </div>
  );
};
